import React, { useContext } from 'react';
import { matchPath } from 'react-router-dom';
import { EventSource } from './analyticsService';

const getEventSourceFromLocationPathname = (pathname?: string): EventSource | undefined => {
    if (!pathname) {
        return undefined;
    }
    if (pathname === '/search') {
        return EventSource.BUSINESS;
    }
    if (pathname === '/profile') {
        return EventSource.PROFILE;
    }
    if (matchPath('/profile/:businessId', pathname)) {
        return EventSource.PROFILE;
    }
    if (matchPath('partner/registration', pathname)) {
        return EventSource.PARTNER_REGISTRATION;
    }
    if (matchPath('business/posts/:postId', pathname)) {
        return EventSource.POST;
    }
    if (matchPath('businesses/:businessId/posts/:postId', pathname)) {
        return EventSource.POST;
    }
    if (matchPath('collections/:collectionId', pathname)) {
        return EventSource.COLLECTION;
    }
    if (matchPath('businesses/:businessId/*', pathname)) {
        return EventSource.BUSINESS;
    }

    return undefined;
};

export interface LocationContextPayload {
    currentLocation?: string;
    previousLocation?: string;
}

export const LocationContext = React.createContext<LocationContextPayload>({});

export function useEventSource() {
    const locationContext = useContext(LocationContext);

    return {
        eventSource: getEventSourceFromLocationPathname(locationContext.currentLocation),
        prevEventSource: getEventSourceFromLocationPathname(locationContext.previousLocation),
    };
}
